module.exports = __webpack_public_path__ + "static/media/icon_add.7a42ba9f.svg";